module.exports = __webpack_public_path__ + "img/05.a2c1707d.png";